module.exports = __webpack_public_path__ + "static/media/paff-bg.ae6173b5.mp4";